import React from 'react';
import PropTypes from 'prop-types';
import { Link, Route } from 'react-router-dom';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import ListItemText from '@material-ui/core/ListItemText';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';

import registry from 'react-mui-lib/registry';


const itemStyles = theme => ({
    menuItem: {
        display: 'inline-flex',
        '&:hover': {
            color: theme.palette.primary.main,
            backgroundColor: 'rgba(11, 173, 236, 0.08)'
        }
    },
    litext: {
        padding: '0'
    },
    addText: {
        fontSize: '24px',
        fontWeight: 'bold',
        color: theme.palette.primary.main
    }
});

const _item = ({to, label, classes, textClass}) =>
    <Route path={to} exact children={({ match }) =>
        <MenuItem component={Link}
                  to={to}
                  selected={!!match}
                  className={classes.menuItem}>
            <ListItemText primary={label}
                          classes={textClass ? { primary: textClass } : undefined}
                          className={!textClass ? classes.litext : undefined} />
        </MenuItem>
    } />;

const Item = withStyles(itemStyles)(_item);

const _add_item = ({to, classes}) =>
    <Route path={to} exact children={({ match }) =>
        <MenuItem component={Link}
                  to={to}
                  selected={!!match}
                  className={classes.menuItem}>
            <ListItemText primary="+ Добавить задание"
                          classes={{ primary: classes.addText }}
                          className={classes.litext} />
        </MenuItem>
    } />;

const AddItem = withStyles(itemStyles)(_add_item);

const _btn_item = ({onClick, label, classes}) =>
    <MenuItem onClick={onClick}
              className={classes.menuItem}>
        <ListItemText primary={label}
                      className={classes.litext} />
    </MenuItem>;

const BtnItem = withStyles(itemStyles)(_btn_item);


const selectorStyles = {
    container: {
        marginBottom: '24px'
    },
    menuList: {
    },
    text: {
        display: 'inline-block',
        padding: '16px 8px',
        color: 'rgba(0, 0, 0, 0.6)'
    }
};

class RoundSelector extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            tasksHintOpen: false
        };

        this.controller = registry.get('round_selector_controller');
        this.game_controller = registry.get('game_form_controller');
    }

    onTasksHint = () => this.setState({ tasksHintOpen: true });

    onTasksHintClose = () => this.setState({ tasksHintOpen: false });

    render() {
        const c = this;
        const { classes } = c.props;
        const { rows, game_id } = c.controller.state;

        const game_name = c.game_controller.getModel('name').getModelValue();

        return <Card className={classes.container}>
            <CardContent>
                <MenuList className={classes.menuList}>
                    <Item to={`/admin/game/${game_id}/edit`}
                          label={game_name || "Игра"} />

                    <span className={classes.text}>
                        Задания:
                    </span>

                    {rows.map((row, key) =>
                        <Item key={key}
                              to={`/admin/game/${game_id}/round/${row.id}`}
                              label={`${row.round_no}`} />
                    )}

                    <AddItem to={`/admin/game/${game_id}/round`} />

                    <Item to={`/admin/game/${game_id}/participants`}
                          label="Участники" />

                    <BtnItem label="Предпросмотр"
                             onClick={() => c.props.openPreview()} />
                </MenuList>

                <Dialog open={c.state.tasksHintOpen}
                        onClose={c.onTasksHintClose}>
                    <DialogContent>
                        <DialogContentText>
                            Создайте не менее трех заданий, чтобы игра была видна.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={c.onTasksHintClose}
                                color="primary"
                                variant="contained"
                                autoFocus>
                            ОК
                        </Button>
                    </DialogActions>
                </Dialog>
            </CardContent>
        </Card>;
    }

    componentWillMount() {
        this.controller.loadForGameId(this.props.game_id);
        window.addEventListener('game-tasks-hint', this.onTasksHint);
    }

    componentWillUnmount() {
        window.removeEventListener('game-tasks-hint', this.onTasksHint);
    }
}

RoundSelector.propTypes = {
    game_id: PropTypes.string.isRequired,
};

export default connect(
    /* mapStateToProps */ state => ({
        state__: state
    }),
    /* mapDispatchToProps */ state => ({
    })
)(withStyles(selectorStyles)(RoundSelector));
